if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      
      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          if (document.documentElement.classList.contains('menu-open')) {
            document.documentElement.classList.remove('menu-open');
            document.body.classList.remove('overflow-hidden');
          }
        }
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('.mobile-toggle');
        if (!btn) return;
        e.preventDefault();
        const opening = !document.documentElement.classList.contains('menu-open');
        const wrapper = this.toggle || document.querySelector('.mobile-toggle-wrapper');
        this.header_el = this.header_el || (this.header_section && this.header_section.querySelector('.header'));
        if (opening) {
          document.documentElement.classList.add('menu-open');
          document.body.classList.add('overflow-hidden');
          if (wrapper) {
            wrapper.classList.add('active');
            try { wrapper.setAttribute('open', ''); } catch (e) {}
          }
          try {
            if (this.header_el) {
              this.header_el.classList.add('is-sticky', 'is-sticky-active');
            }
          } catch (err) {}
          try {
            if (this.header_section && typeof this.header_section.scrollIntoView === 'function') {
              this.header_section.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
          } catch (err) {}
          try {
            const annSection = document.querySelector('.announcement-bar-section');
            if (annSection && this.header_section) {
              if (!annSection.__moved) {
                annSection.__prevParent = annSection.parentNode;
                annSection.__prevNext = annSection.nextSibling;
                annSection.__moved = true;
              }
              const parent = this.header_section.parentNode;
              parent.insertBefore(annSection, this.header_section.nextSibling);
              annSection.style.display = 'block';
              annSection.style.visibility = 'visible';
              annSection.style.opacity = '1';
            }
          } catch (err) {}
        } else {
          document.documentElement.classList.remove('menu-open');
          document.body.classList.remove('overflow-hidden');
          if (wrapper) {
            wrapper.classList.remove('active');
            try { wrapper.removeAttribute('open'); } catch (e) {}
          }
          try {
            if (this.header_el) {
              this.header_el.classList.remove('is-sticky', 'is-sticky-active');
            }
          } catch (err) {}
          try {
            const annSection = document.querySelector('.announcement-bar-section');
            if (annSection && annSection.__moved) {
              const prevParent = annSection.__prevParent;
              const prevNext = annSection.__prevNext;
              if (prevParent) {
                prevParent.insertBefore(annSection, prevNext);
              }
              delete annSection.__moved;
              delete annSection.__prevParent;
              delete annSection.__prevNext;
            }
            if (annSection) {
              annSection.style.display = '';
              annSection.style.visibility = '';
              annSection.style.opacity = '';
            }
          } catch (err) {}
        }
      });

      if (this.menu) {
        this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => this.setupSlideshowScrollDetection(), 100);
        });
      } else {
        setTimeout(() => this.setupSlideshowScrollDetection(), 100);
      }
    }

setupSlideshowScrollDetection() {
  const isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/' || window.location.pathname === '/index';
  if (!isHomepage) {
    return;
  }

  const header = this;
  if (!header.classList.contains('transparent--true')) {
    return;
  }

  const headerElement = this.header_section?.querySelector('.header') || document.querySelector('.header');
  
  if (!headerElement) {
    return;
  }

  const shopifySections = document.querySelectorAll('[id*="shopify-section"]');
  const contentSections = Array.from(shopifySections).filter(section => 
    !section.id.includes('header') && 
    !section.id.includes('announcement')
  );
  
  const secondSection = contentSections[1];
  
  if (!secondSection) {
    return;
  }
  
  const handleScroll = debounce(() => {
    const isMenuOpen = document.documentElement.classList.contains('menu-open');
    
    if (isMenuOpen) {
      return;
    }
    
    const secondSectionTop = secondSection.getBoundingClientRect().top;
    const headerHeight = headerElement.clientHeight || 70;
    const isPastFirstSection = secondSectionTop <= headerHeight;

    if (isPastFirstSection) {
      if (!headerElement.classList.contains('is-sticky')) {
        headerElement.classList.add('is-sticky', 'is-sticky-active');
        // Force background change with inline style
        headerElement.style.setProperty('background', 'white', 'important');
      }
    } else {
      if (headerElement.classList.contains('is-sticky')) {
        headerElement.classList.remove('is-sticky', 'is-sticky-active');
        // Remove inline style to restore transparent
        headerElement.style.removeProperty('background');
      }
    }
  }, 10);

  window.addEventListener('scroll', handleScroll, { passive: true });
  
  const checkDelay = document.body.classList.contains('animations-true') ? 1500 : 800;
  setTimeout(() => {
    handleScroll();
  }, checkDelay);
}

    
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      
      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          if (document.documentElement.classList.contains('menu-open')) {
            document.documentElement.classList.remove('menu-open');
            document.body.classList.remove('overflow-hidden');
          }
        }
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('.mobile-toggle');
        if (!btn) return;
        e.preventDefault();
        const opening = !document.documentElement.classList.contains('menu-open');
        const wrapper = this.toggle || document.querySelector('.mobile-toggle-wrapper');
        this.header_el = this.header_el || (this.header_section && this.header_section.querySelector('.header'));
        if (opening) {
          document.documentElement.classList.add('menu-open');
          document.body.classList.add('overflow-hidden');
          if (wrapper) {
            wrapper.classList.add('active');
            try { wrapper.setAttribute('open', ''); } catch (e) {}
          }
          try {
            if (this.header_el) {
              this.header_el.classList.add('is-sticky', 'is-sticky-active');
            }
          } catch (err) {}
          // Ensure header is visible when the menu opens (page may be scrolled).
          try {
            if (this.header_section && typeof this.header_section.scrollIntoView === 'function') {
              this.header_section.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
          } catch (err) {}
          try {
            const annSection = document.querySelector('.announcement-bar-section');
            if (annSection && this.header_section) {
              annSection.__prevStyle = {
                position: annSection.style.position || '',
                top: annSection.style.top || '',
                left: annSection.style.left || '',
                right: annSection.style.right || '',
                width: annSection.style.width || '',
                zIndex: annSection.style.zIndex || '',
                display: annSection.style.display || '',
                visibility: annSection.style.visibility || '',
                opacity: annSection.style.opacity || ''
              };
              
              annSection.style.position = 'fixed';
              annSection.style.left = '0';
              annSection.style.right = '0';
              annSection.style.width = '100%';
              annSection.style.zIndex = '9999';
              annSection.style.display = 'block';
              annSection.style.visibility = 'visible';
              annSection.style.opacity = '1';
              
              const updateAnnTop = () => {
                if (!this.header_section) return;
                const headerHeight = Math.ceil(this.header_section.getBoundingClientRect().height) || 70;
                annSection.style.top = (headerHeight > 0 ? headerHeight : 70) + 'px';
              };
              updateAnnTop();
              setTimeout(updateAnnTop, 50);
            }
          } catch (err) {}
        } else {
          document.documentElement.classList.remove('menu-open');
          document.body.classList.remove('overflow-hidden');
          if (wrapper) {
            wrapper.classList.remove('active');
            try { wrapper.removeAttribute('open'); } catch (e) {}
          }
          try {
            if (this.header_el) {
              this.header_el.classList.remove('is-sticky', 'is-sticky-active');
            }
          } catch (err) {}
          try {
            const annSection = document.querySelector('.announcement-bar-section');
            if (annSection && annSection.__prevStyle) {
              const s = annSection.__prevStyle;
              annSection.style.position = s.position;
              annSection.style.top = s.top;
              annSection.style.left = s.left;
              annSection.style.right = s.right;
              annSection.style.width = s.width;
              annSection.style.zIndex = s.zIndex;
              annSection.style.display = s.display;
              annSection.style.visibility = s.visibility;
              annSection.style.opacity = s.opacity;
              delete annSection.__prevStyle;
            }
          } catch (err) {}
        }
      });

      // Buttons inside the mobile menu (submenus/back buttons)
      if (this.menu) {
        this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => this.setupSlideshowScrollDetection(), 100);
        });
      } else {
        setTimeout(() => this.setupSlideshowScrollDetection(), 100);
      }
    }

    setupSlideshowScrollDetection() {
      const isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/' || window.location.pathname === '/index';
      if (!isHomepage) {
        return;
      }

      const header = this;
      if (!header.classList.contains('transparent--true')) {
        return;
      }

      const verticalSlideshow = document.querySelector('vertical-slideshow');
      if (!verticalSlideshow) {
        return;
      }

      const slideshowSection = verticalSlideshow.closest('.shopify-section');
      if (!slideshowSection) {
        return;
      }

      const slides = verticalSlideshow.querySelectorAll('.vertical-slideshow--slide');
      if (slides.length === 0) {
        return;
      }

      const lastSlide = slides[slides.length - 1];
      
      const handleScroll = debounce(() => {
        const currentScrollY = window.scrollY;
        const viewportBottom = currentScrollY + window.innerHeight;
        const isMenuOpen = document.documentElement.classList.contains('menu-open');
        
        if (isMenuOpen) {
          return;
        }
        
        const slideshowRect = verticalSlideshow.getBoundingClientRect();
        const slideshowTop = slideshowRect.top + currentScrollY;
        const slideshowHeight = verticalSlideshow.offsetHeight;
        const slideshowBottom = slideshowTop + slideshowHeight;
        
        const threshold = 100;
        const isPastSlideshow = viewportBottom > slideshowBottom - threshold;

        if (isPastSlideshow) {
          if (!header.classList.contains('is-sticky')) {
            header.classList.add('is-sticky', 'is-sticky-active');
          }
        } else {
          if (header.classList.contains('is-sticky')) {
            header.classList.remove('is-sticky', 'is-sticky-active');
          }
        }
      }, 10);

      window.addEventListener('scroll', handleScroll, { passive: true });
      
      const checkDelay = document.body.classList.contains('animations-true') ? 1500 : 800;
      setTimeout(() => {
        handleScroll();
      }, checkDelay);
    }

    
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}